import React, { Component } from 'react';
import './style.scss';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';

/**
 * Attivazione modale tramite button
 * 
 *      "click" : se clicco OK, attivo una determinata funzione
 *      "titleModal" : il titolo della modale quando si apre
 *      "contentModal" : il contenuto che deve essere mostrato nella modale
 *      "cnModal" : se voglio aggiungere una classe per la modale
 *      "stateModal" : stato della modale (booleano)
 *      "confirmLabel" : testo del pulsante di conferma (default OK)
 *      "confirmClass" : classe bootstrap del pulsante di conferma (default btn-primary)
 *      "showCancel" : se true mostra anche il pulsante Annulla
 */
export default class index extends Component {
    render() {
        const { stateModal, toggle, titleModal, contentModal, cnModal, click, confirmLabel = 'OK', confirmClass = 'btn-primary', showCancel } = this.props;
        return (
            <Dialog open={stateModal} disableScrollLock={true} className={`appModal appModal--sm${cnModal ? ` ${cnModal}` : ''}`}>
                <DialogTitle>
                    {titleModal}
                    <IconButton
                        aria-label="close"
                        onClick={toggle}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <i className='fas fa-times'></i>
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    {contentModal}
                </DialogContent>

                {
                    click &&
                    <DialogActions>
                        {showCancel && <button type="button" className="btn btn-outline-secondary" onClick={toggle}>Annulla</button>}
                        <button type="button" className={`btn ${confirmClass}`} onClick={click}>{confirmLabel}</button>
                    </DialogActions>
                }
            </Dialog>
        )
    }
}